
const box2TabImg = document.querySelectorAll(".box2-div .div-top .div-img picture");
const box2TabItem = document.querySelectorAll(".box2-div .div-tab .tab");

const box4TabText = document.querySelectorAll(".box4-div2 .item-ul-text li");
const box4TabItem = document.querySelectorAll(".box4-div2 .item-ul-icon li");

const box6TabImg = document.querySelectorAll("#box6-splide .tab .left picture");
const box6TabItem = document.querySelectorAll("#box6-splide .tab .right .ul-icon li");
const box6ItemIconUl = document.querySelectorAll(".splide-ul li");


const box8Div = document.querySelector(".box8-div");
const box8Ul = document.querySelector(".box8-ul");
const box8Item = document.querySelectorAll(".box8-ul li");
const box8ButLi = document.querySelectorAll(".box8-ul-but ul li");
const box8ButLeft = document.querySelector(".box8-ul-but .left");
const box8ButRight = document.querySelector(".box8-ul-but .right");

let widthW = window.innerWidth;
let clickTrue = Math.trunc(box8Ul.offsetWidth/widthW) + 1
let clickSub = 0
let clickW = 0
const box8LiW = box8Item[0].offsetWidth;

box8Div.addEventListener('scroll', () => {
    const scrollDistance = box8Div.scrollLeft;
    // console.log('当前横向滑动距离:', scrollDistance);
});



box2TabItem.forEach((link,index) => {
  
  link.addEventListener('mouseover', (e)=>{

    box2TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box2TabItem.forEach(item => {
      item.classList.remove("active");
    })

    box2TabItem[index].classList.add("active");
    box2TabImg[index].classList.add("active");
  })

  link.addEventListener('click', (e)=>{

    box2TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box2TabItem.forEach(item => {
      item.classList.remove("active");
    })

    box2TabItem[index].classList.add("active");
    box2TabImg[index].classList.add("active");
  })

})

box4TabItem.forEach((link,index) => {
  
  link.addEventListener('mouseover', (e)=>{

    box4TabText.forEach(item => {
      item.classList.remove("active");
    })
    box4TabItem.forEach(item => {
      item.classList.remove("active");
    })

    box4TabItem[index].classList.add("active");
    box4TabText[index].classList.add("active");
  })

  link.addEventListener('click', (e)=>{

    box4TabText.forEach(item => {
      item.classList.remove("active");
    })
    box4TabItem.forEach(item => {
      item.classList.remove("active");
    })

    box4TabItem[index].classList.add("active");
    box4TabText[index].classList.add("active");
  })

})

box6TabItem.forEach((link,index) => {
  
  link.addEventListener('mouseover', (e)=>{

    box6TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box6TabItem.forEach(item => {
      item.classList.remove("active");
    })
    box6ItemIconUl.forEach(item => {
      item.classList.remove("active");
    })
    

    box6TabItem[index].classList.add("active");
    box6TabImg[index].classList.add("active");
    box6ItemIconUl[index].classList.add("active");
  })

  link.addEventListener('click', (e)=>{

    box6TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box6TabItem.forEach(item => {
      item.classList.remove("active");
    })
    box6ItemIconUl.forEach(item => {
      item.classList.remove("active");
    })

    box6TabItem[index].classList.add("active");
    box6TabImg[index].classList.add("active");
    box6ItemIconUl[index].classList.add("active");
  })

})

box6ItemIconUl.forEach((link,index) => {
  
  link.addEventListener('mouseover', (e)=>{

    box6TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box6TabItem.forEach(item => {
      item.classList.remove("active");
    })
    box6ItemIconUl.forEach(item => {
      item.classList.remove("active");
    })
    

    box6TabItem[index].classList.add("active");
    box6TabImg[index].classList.add("active");
    box6ItemIconUl[index].classList.add("active");
  })

  link.addEventListener('click', (e)=>{

    box6TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box6TabItem.forEach(item => {
      item.classList.remove("active");
    })
    box6ItemIconUl.forEach(item => {
      item.classList.remove("active");
    })

    box6TabItem[index].classList.add("active");
    box6TabImg[index].classList.add("active");
    box6ItemIconUl[index].classList.add("active");
  })

})

box8ButLeft.addEventListener('click', ()=>{ 
  if(clickSub>0){
    clickSub-=1;
    clickW += box8LiW
    box8Ul.style.transform = `translateX(${clickW}px)`;
  }

  if(clickSub==0){
    box8ButLi.forEach(item => {
      item.classList.remove("is-false");
    })
    box8ButLi[0].classList.add("is-false");
  }
})

box8ButRight.addEventListener('click', ()=>{
  if(clickSub<clickTrue){
    clickSub+=1;
    clickW -= box8LiW
    box8Ul.style.transform = `translateX(${clickW}px)`;
  }

  if(clickSub==clickTrue){
    box8ButLi.forEach(item => {
      item.classList.remove("is-false");
    })
    box8ButLi[1].classList.add("is-false");
  }
})


ScrollTrigger.matchMedia({
  "(min-width: 1025px)": function(){
    ScrollTrigger.create({
      trigger: '.box3',
      start: 'top top',
      end:'+=280% bottom',
      scrub: true,
      pin:true,
      animation:
        gsap.timeline()
        .to('.splide-img',{transform: 'scale(1)'})
        .to('.splide-img-box .img-text',{display: 'none'},"0")
        .to('.splide-img .img2',{display: 'none'},"0")
        .to('.splide-img .img1',{left: '75%'})
        .to('.splide-text .li1',{opacity: 1,transform: 'translateY(0px)'})
        .to('.splide-text .li2',{opacity: 1,transform: 'translateY(0px)'})
        .to('.splide-text .li3',{opacity: 1,transform: 'translateY(0px)'})
    })
  },
  "(max-width: 1025px)": function(){}
})




gsap.timeline({
  scrollTrigger: {
    trigger: '.box8',
    start: 'top center',
    end: 'center center',
    // toggleActions: 'play none none none' // 在触发时播放动画，之后不再重复
    toggleActions: 'play none none reverse' // 滚下时动画重复播放
  }
})
.to('.box8-ul li img',
  {
    opacity: 1,
    transform: 'translateY(0px)',
    stagger: 0.2,
    ease: 'power2.out' // 可选：缓动效果
  }
);

let marker = document.querySelector("#marker2");
let tabItem = document.querySelectorAll(".box9-tab a");
let tabItemContent = document.querySelectorAll(".box9-tab-c-item");

function indicator(e){
  marker.style.left = e.offsetLeft + 'px';
  marker.style.width = e.offsetWidth + 'px';
}

tabItem.forEach((link,index) => {
  
  link.addEventListener('mouseover', (e)=>{
    indicator(e.target)

    tabItemContent.forEach(item => {
      item.classList.remove("box9-active");
    })
    tabItem.forEach(item => {
      item.classList.remove("box9-tab-active");
    })

    tabItem[index].classList.add("box9-tab-active");
    tabItemContent[index].classList.add("box9-active");
  })

})